<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <v-flex pl-5 pb-3>
            <v-layout justify-start align-content-start row wrap>
              <v-flex xs12>
                <h4>Booking Settings</h4>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-checkbox v-model="allowGuestBookings" label="Allow Guest Bookings"></v-checkbox>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-checkbox v-model="allowCashBookings" label="Allow Cash Bookings"></v-checkbox>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-currency-field
                      type="number"
                      v-model="maxCashBookingAmount"
                      label="Max Cash Amount"
                      v-bind="currency_config"
                      :min="0"
                    ></v-currency-field>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-checkbox v-model="enableCancellationFee" label="Enable Cancellation Fee"></v-checkbox>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-text-field
                      type="number"
                      v-model="cancellationTimeThresholdHours"
                      label="Cancellation Threshold (Hours)"
                    ></v-text-field>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex shrink pr-2>
                    <v-currency-field
                      type="number"
                      v-model="cancellationFee"
                      label="Cancellation Fee"
                      v-bind="currency_config"
                      :min="0"
                    ></v-currency-field>
                  </v-flex>
                </v-row>
              </v-flex>
            </v-layout>
            <v-btn @click="update">Update</v-btn>
          </v-flex>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import SimpleCurrencyInput from "@/components/widget/input/SimpleCurrencyInput.vue";

import qs from "qs";

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    SimpleCard,
    SimpleCurrencyInput
  },
  data: function() {
    return {
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true
      },
      loading: false,
      allowGuestBookings: false,
      allowCashBookings: false,
      maxCashBookingAmount: 0,
      enableCancellationFee: false,
      cancellationFee: 0
    };
  },
  mounted: async function() {
    this.getBookingSettings();
  },
  methods: {
    getBookingSettings: function(p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/booking/web/settings/get`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.allowGuestBookings = res.data.allowGuestBookings;
            vm.allowCashBookings = res.data.allowCashBookings;
            vm.maxCashBookingAmount = res.data.maxCashBookingAmount / 100;
            vm.enableCancellationFee = res.data.enableCancellationFee;
            vm.cancellationFee = res.data.cancellationFee / 100;
            vm.cancellationTimeThresholdHours =
              res.data.cancellationTimeThresholdHours;
          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    update: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${
        this.$store.state.apiUrl
      }/booking/web/settings/update?allowGuestBookings=${
        this.allowGuestBookings
      }&allowCashBookings=${this.allowCashBookings}&maxCashBookingAmount=${(
        this.maxCashBookingAmount * 100
      ).toFixed(0)}&enableCancellationFee=${
        this.enableCancellationFee
      }&cancellationFee=${(this.cancellationFee * 100).toFixed(
        0
      )}&cancellationTimeThresholdHours=${this.cancellationTimeThresholdHours}`;

      var completed = this.success;

      console.log(url);

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            alert("Settings Updated");
          } else {
            alert("Settings failed to update: " + res.data.error.message);
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
        });
    }
  }
};
</script>
